import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";

type Props = {
  pricingType: string;
  price: string;
  currency: string;
};

const PropertyPricingViewer = ({ currency, price, pricingType }: Props) => {
  if (!price) {
    return null;
  }
  return (
    <div>
      <Flex>
        <Typography fontWeight="bold">Pricing Type:</Typography>
        <Typography>{pricingType}</Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">Price:</Typography>
        <Typography>{price}</Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">Currency:</Typography>
        <Typography>{currency}</Typography>
      </Flex>
    </div>
  );
};

export default PropertyPricingViewer;
